import type { ThemeId } from './theme-meta.js';
import type { ThemePreference } from './theme-preference-storage.js';

/**
 * FR-07 - čistá funkce rozlišení efektivní šablony. Platí stejně na aplikačním i marketingovém
 * hostu (`ThemeEffect` se mountuje v obou větvích main.tsx).
 */
export function resolveEffectiveTheme(preference: ThemePreference, systemPrefersDark: boolean): ThemeId {
  if (preference === 'light') return 'light';
  if (preference === 'dark') return 'dark';
  return systemPrefersDark ? 'dark' : 'light';
}
